(function () {
  var core = window.DebugPanelCore;
  if (!core) {
    return;
  }

  var debug_console_emit_selected = document.getElementById("debug-console-emit-selected");
  var debug_console_emit_burst = document.getElementById("debug-console-emit-burst");
  var debug_console_demo_clear = document.getElementById("debug-console-demo-clear");
  var debug_console_demo_status = document.getElementById("debug-console-demo-status");
  var debug_console_preset = document.getElementById("debug-console-preset");
  var debug_console_custom_controls = document.getElementById("debug-console-custom-controls");
  var debug_console_count = document.getElementById("debug-console-count");
  var debug_console_message = document.getElementById("debug-console-message");
  var debug_console_level_log = document.getElementById("debug-console-level-log");
  var debug_console_level_info = document.getElementById("debug-console-level-info");
  var debug_console_level_warn = document.getElementById("debug-console-level-warn");
  var debug_console_level_error = document.getElementById("debug-console-level-error");
  var debug_console_duplicates = document.getElementById("debug-console-duplicates");

  function setStatus(text) {
    if (debug_console_demo_status) {
      debug_console_demo_status.textContent = text;
    }
  }

  function isCustomMode() {
    return !!(debug_console_preset && debug_console_preset.value === "custom");
  }

  function getSelectedLevels() {
    var levels = [];
    if (debug_console_level_log && debug_console_level_log.checked) levels.push("log");
    if (debug_console_level_info && debug_console_level_info.checked) levels.push("info");
    if (debug_console_level_warn && debug_console_level_warn.checked) levels.push("warn");
    if (debug_console_level_error && debug_console_level_error.checked) levels.push("error");
    return levels;
  }

  function sanitizeCount(value) {
    var parsed = parseInt(value, 10);
    if (isNaN(parsed)) parsed = 1;
    return Math.max(1, Math.min(500, parsed));
  }

  function applyPreset(name) {
    if (!debug_console_level_log || !debug_console_level_info || !debug_console_level_warn || !debug_console_level_error) {
      return;
    }

    if (name === "warnings") {
      debug_console_level_log.checked = false;
      debug_console_level_info.checked = false;
      debug_console_level_warn.checked = true;
      debug_console_level_error.checked = true;
      if (debug_console_count) debug_console_count.value = "10";
      if (debug_console_message) debug_console_message.value = "Warning/Error demo";
    } else if (name === "errors") {
      debug_console_level_log.checked = false;
      debug_console_level_info.checked = false;
      debug_console_level_warn.checked = false;
      debug_console_level_error.checked = true;
      if (debug_console_count) debug_console_count.value = "16";
      if (debug_console_message) debug_console_message.value = "Error storm demo";
    } else if (name === "basic") {
      debug_console_level_log.checked = true;
      debug_console_level_info.checked = true;
      debug_console_level_warn.checked = true;
      debug_console_level_error.checked = true;
      if (debug_console_count) debug_console_count.value = "8";
      if (debug_console_message) debug_console_message.value = "Console test message";
    }
  }

  function setCustomControlsEnabled(enabled) {
    if (!debug_console_custom_controls) {
      return;
    }

    var targets = debug_console_custom_controls.querySelectorAll("input, select, button, textarea");
    for (var i = 0; i < targets.length; i++) {
      targets[i].disabled = !enabled;
    }

    debug_console_custom_controls.setAttribute("aria-disabled", enabled ? "false" : "true");
    debug_console_custom_controls.classList.toggle("debug-console-controls--disabled", !enabled);
  }

  function emitSelectedLogs() {
    var levels = getSelectedLevels();
    if (!levels.length) {
      setStatus("Status: Select at least one log level.");
      return;
    }

    var messageBase = (debug_console_message && debug_console_message.value.trim()) || "Console test message";
    var chosenLevel = levels[Math.floor(Math.random() * levels.length)];
    console[chosenLevel]("[" + chosenLevel + "] " + messageBase);
    setStatus("Status: Emitted 1 entry (" + chosenLevel + ").");
  }

  function emitBurstLogs() {
    var count = sanitizeCount(debug_console_count ? debug_console_count.value : 1);
    if (debug_console_count) {
      debug_console_count.value = String(count);
    }

    var levels = getSelectedLevels();
    if (!levels.length) {
      setStatus("Status: Select at least one log level.");
      return;
    }

    var messageBase = (debug_console_message && debug_console_message.value.trim()) || "Burst message";
    var total = count;
    var duplicateMode = isCustomMode() && !!(debug_console_duplicates && debug_console_duplicates.checked);
    var lastLevel = null;
    var lastMessage = null;

    for (var i = 0; i < total; i++) {
      var level;
      var text;
      if (duplicateMode && i > 0 && Math.random() < 0.45) {
        level = lastLevel;
        text = lastMessage;
      } else {
        level = levels[Math.floor(Math.random() * levels.length)];
        text = "[burst:" + level + "] " + messageBase + (duplicateMode ? "" : " #" + (i + 1));
      }
      console[level](text);
      lastLevel = level;
      lastMessage = text;
    }

    setStatus("Status: Emitted burst of " + total + " mixed entries" + (duplicateMode ? " with random duplicate runs." : "."));
  }

  if (debug_console_preset) {
    debug_console_preset.addEventListener("change", function () {
      var presetValue = debug_console_preset.value;
      if (presetValue !== "custom") {
        applyPreset(presetValue);
      }
      var customEnabled = presetValue === "custom";
      setCustomControlsEnabled(customEnabled);
      setStatus(customEnabled ? "Status: Custom controls enabled." : "Status: Preset applied.");
    });
  }

  if (debug_console_emit_selected) {
    debug_console_emit_selected.addEventListener("click", emitSelectedLogs);
  }

  if (debug_console_emit_burst) {
    debug_console_emit_burst.addEventListener("click", emitBurstLogs);
  }

  if (debug_console_demo_clear) {
    debug_console_demo_clear.addEventListener("click", function () {
      core.clearLogs();
      setStatus("Status: Logs cleared.");
    });
  }

  var initialPreset = debug_console_preset ? debug_console_preset.value : "custom";
  if (initialPreset !== "custom") {
    applyPreset(initialPreset);
  }
  setCustomControlsEnabled(initialPreset === "custom");
  setStatus("Status: Ready");
})();
